import { render, staticRenderFns } from "./MovimentosAba.vue?vue&type=template&id=eb831558"
import script from "./MovimentosAba.vue?vue&type=script&lang=js"
export * from "./MovimentosAba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports